<template>
<div id="property-reviews" :data-size="size">
    <div class="reviewsWrapper" v-if="reviews && (reviews.length > 0)">
        <div class="reviewsTitle">
            <h5 class="property-reviews__title">Recensioni</h5>
            <!--<div class="ml-3"><Stars :hotelRating="totalRating" /></div>-->
        </div>
        <small class="reviewsSubitle">Estratto di {{totalReviews}} recensioni verificate</small>
        <div class="slick-wrapper">
            <Slick
                ref="slick-reviews"
                :options="slickOptions"
                @afterChange="reviewsSlickHandleAfterChange"
                @swipe="reviewsSlickHandleSwipe"
            >
                <div v-for="(value,index) in reviews" v-bind:key="index">
                    <div class="review" v-b-modal="'review-'+size+'-'+index">
                        <div class="review__icons">
                            <img class="review__avatar" :src="value.avatar" />
                            <span class="review__rating">{{value.rating}}/5</span>
                        </div>
                        <!--<div class="review__stars">
                            <Stars :hotelRating="parseFloat(value.rating)" />
                        </div>-->
                        <div class="review__content">
                            <div class="small">
                                <b>{{value.user}}</b> {{value.data}}
                                <br>
                                <i>{{value.verification_source}}</i>
                            </div>
                            <h5 class="review__title">{{value.title}}</h5>
                            <p class="review__text">{{value.text}}</p>
                        </div>
                    </div>
                    <b-modal :id="'review-'+size+'-'+index" hide-footer :title="value.title" @change="reviewsModalOpened">
                        <b-container fluid class="mt-4 mb-4">
                            <div class="small">
                                <b>{{value.user}}</b> - {{value.data}}
                                <br>
                                <i>{{value.verification_source}}</i>
                                <br><br>
                            </div>
                            <p>{{value.text}}</p>
                        </b-container>
                    </b-modal>
                </div>
            </Slick>
            <div class="reviews__dots">
                <span variant="light" class="slick-arrow" :id="size+'-slick-prev-review'"><SvgChevronLeft /></span>
                <span variant="light" class="slick-arrow" :id="size+'-slick-next-review'"><SvgChevronRight /></span>
            </div>
        </div>
    </div>
    <div v-else-if="reviews && (reviews.length == 0)">
        <small>Non ci sono ancora recensioni per questa struttura.</small>
        <br><br>
    </div>
    <Spinner v-else />
</div>    
</template>

<script>
import Vue from 'vue'
import Api from '../../../api'
import { mapGetters } from 'vuex'
import Slick from 'vue-slick'
import Spinner from '../../atoms/spinner'
import SvgChevronRight from '../../svg/chevron-right'
import SvgChevronLeft from '../../svg/chevron-left'
import { custom_event } from '@/integrations'

export default {
    name: 'property-reviews',
    components:
    {
        Slick,
        Spinner,
        SvgChevronLeft,
        SvgChevronRight,
    },
    props:
    {
        size: String,
    },
    computed: mapGetters({
        property: 'getPropertyDetail',
    }),
    data() {
        return {
            reviews: [],
            totalRating: 0,
            totalReviews: 0,
            slickOptions: {
                autoplay: (this.$config.guiSettings.autoplaySpeedReviews != 0),
                autoplaySpeed: this.$config.guiSettings.autoplaySpeedReviews,
                slidesToShow: ((this.size == 'small' | this.size == 'compact') ? 1 : 3),//1 nella sidebar, 3 in fondo a pagina dettaglio
                slidesToScroll: 1,
                infinite: true,
                dots:false,
                prevArrow: '#'+this.size+'-slick-prev-review',
                nextArrow: '#'+this.size+'-slick-next-review',
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }]
            },
        }
    },
    
    watch: {
        property: function () {
            this.getPropertyReviews()
        }
    },
    
    methods: {
        getPropertyReviews()
        {
            let _this = this
            _this.reviews = []
            Api
                .getReviews({
                        property_id: parseInt(_this.property.property_id),
                        token: Vue.prototype.$config.token
                    })
                .then((data) => {
                    let sum = 0
                    
                    _this.reviews = []
                    _this.totalRating = 0
                    _this.totalReviews = 0
                    
                    if(data) {
                        data.reviews.forEach(review => {
                            sum = sum + parseFloat(review.rating)
                        });
                        _this.reviews = data.reviews
                        _this.totalRating = sum / (data.reviews.length)
                        _this.totalReviews = data.count
                    }
                })
        },

        reviewsModalOpened(){
            custom_event('reviewsModalOpened', undefined, undefined, 'userBehaviour')

            if(window.LogRocket) window.LogRocket.track('reviewsModalOpened')
        },

        // event, slick, currentSlide
        reviewsSlickHandleAfterChange() {

            custom_event('reviewsSlickInteraction', 'change', undefined, 'userBehaviour')

            if(window.LogRocket) window.LogRocket.track('reviewsSlickInteractionChange')

        },
        
        // event, slick, currentSlide
        reviewsSlickHandleSwipe() {

            custom_event('reviewsSlickInteraction', 'swipe', undefined, 'userBehaviour')

            if(window.LogRocket) window.LogRocket.track('reviewsSlickInteractionSwipe')
        },

    },
    mounted()
    {
        this.getPropertyReviews()
    }    
}
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../../scss/_custom.scss';
    #property-reviews
    {
        .slick-list
        {
            padding-left:0.75rem;
            margin-left:-0.75rem;
            margin-top:2rem;
            .slick-slide
            {
                transition:$transition-base;
            }
            .slick-slide:not(.slick-active)
            {
                opacity:0;
            }
        }
        .property-reviews__title
        {
            font-weight:600;
            font-size:23px;
            color:$black;
            margin:0;
        }

        .reviews__dots
        {
            display:flex;
            justify-content: flex-end;
            margin-top:1rem;
            span
            {
                display:flex;
                justify-content: center;
                align-items: center;
                width:38px;
                height:38px;
                background:$white;
                color:$smooth-black;
                border-radius:50%;
                margin-left:10px;
                cursor:pointer;
            }
        }


        .review *
        {
            font-family: "Century Gothic", CenturyGothic, Arial, sans-serif !important;
            color:$black;
            cursor: pointer;
        }
        .review
        {
            background:$white;
            border-radius:$border-radius;
            position:relative;
            margin-top:$grid-gutter-width/2;
            .review__icons
            {
                display: none;
                @include media-breakpoint-up(md)
                {
                    display:flex;
                    align-items:center;
                    transform: translateX(-12px) translateY(-16px);
                }
            }
            .review__content
            {
                padding:$grid-gutter-width/2;
                padding-top:0;//$grid-gutter-width/8;
                position:relative;

                height:260px;
                overflow:hidden;
                &:after
                {
                    content:"";
                    position:absolute;
                    bottom:0;
                    height:80px;
                    left:0;
                    width:100%;
                    background: linear-gradient(0deg, $white, transparent 100%);
                    border-bottom:20px solid $white;
                    border-radius:$border-radius;
                }
            }

            .small
            {
                line-height:120%;
                font-size: 12px;
                margin-bottom:12px;
                margin-top:6px;
            }            

            .review__avatar
            {
                width:44px;
                height:44px;
                border:2px solid $white;
                border-radius: 50%;
                z-index: 1;
            }

            .review__rating
            {
                width:50px;
                height:50px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                background:$gold;
                text-align:center;
                border-radius: 50%;
                color:$white;
                font-weight:600;

                transform: translateX(-4px);
            }

            .review__stars
            {
                position:absolute;
                top:0;
                left:0;
                right:0;
                margin:auto;
                text-align:center;
                z-index: 1;
                transform:translateY(-50%);
            }

            .review__title
            {
                margin-top:0;
            }

            .review__text
            {
                margin-bottom:0;
            }
        }

        &[data-size=compact]
        {
            .reviewsWrapper
            {
                display:flex;
                flex-wrap:wrap;
                justify-content: space-between;
            }
            .reviewsTitle,
            .reviewsSubitle
            {
                display:flex;
                justify-content: center;
                align-items:center;
                //margin-right:1rem;
                display:none;
            }
            .slick-wrapper
            {
                min-width:100%;
                padding:0 30px;
                position:relative;
                .slick-list
                {
                    margin-top:0;
                    margin-left: 0;
                    padding-left: 0;
                }
                #compact-slick-prev-review
                {
                    position:absolute;
                    left:0;
                    top:50%;
                    transform:translateY(-50%);
                    margin:0;
                    padding:0;
                    width:16px;
                }
                #compact-slick-next-review
                {
                    position:absolute;
                    right:0;
                    top:50%;
                    transform:translateY(-50%);
                    margin:0;
                    padding:0;
                    width:16px;
                }
            }
            .review
            {
                margin-top:0;
                display:flex;
                align-items:flex-start;
            }
            .small
            {
                margin:0.5rem 0;
            }
            .review__icons
            {
                transform:none;
                flex:1;
                min-width: 100px;
                max-width: 100px;
                //padding-top:10px;
            }
            .review__content
            {
                flex:1;
                height:140px;
                padding:0 0 0 0.5rem;
            }
            .review__title
            {
                font-size: 1rem;
                margin-bottom:0.5rem;
            }
            .review__text
            {
                font-size: 12px;
                line-height: 120%;
            }
            .reviews__dots
            {
                margin-top:0;
            }
        }

        &[data-size=small]
        {
            .review
            {
                //margin-left:$grid-gutter-width/3;
            }
            .review__icons
            {
                //transform:none;
            }
        }

        &[data-size=large]
        {
            margin:4rem 0;
            @include media-breakpoint-up(sm)
            {
                .review,
                .reviews__dots
                {
                    margin-right:$grid-gutter-width;
                }
            }
        }

    }
</style>